import { configureStore } from '@reduxjs/toolkit';

import appReducer from '../slices/appSlice';

const getStore = (preloadedState = {}) => (
  configureStore({
    reducer: {
      app: appReducer,
    },
    preloadedState,
  })
);

export default getStore;
